<template>
  <div class="matches">
    <v-text-field
      class="input"
      color="green"
      placeholder="Chat suchen ..."
      solo
      rounded
      append-icon="search"
    ></v-text-field>

    <div v-if="matchesArchived.length" class="scrolling-wrapper-top">
      <h4>Inaktive Chats</h4>
      <div
        v-if="matchesArchived && matchesArchived.length"
        class="scrolling-wrapper-flexbox"
        style="margin-top: 10px"
      >
        <ChatInactivePreview
          @click="
            matchChat.type === 'teams'
              ? redirectToChat(
                  matchChat.chat_id,
                  matchChat.logo,
                  matchChat.team ? matchChat.team : matchChat.name,
                  matchChat.contactByDetails,
                )
              : redirectToChat(matchChat.chat_id)
          "
          v-for="matchChat in matchesArchived"
          :key="matchChat.chat_id"
          :picture="matchChat.type === 'teams' ? matchChat.logo : matchChat.profile_pic"
          :msg="matchChat.lastMessage"
          :chat-id="matchChat.chat_id"
          :name="matchChat.type === 'teams' ? matchChat.team : matchChat.player_name"
          :lastMessageDetails="matchChat.lastMessageDetails"
          :inactiveInfo="matchChat.disabledBy"
          :details="matchChat.contactDetails"
        ></ChatInactivePreview>
      </div>
      <v-divider class="divider"></v-divider>
    </div>

    <h3
      v-if="
        scoutsChats.length === 0 &&
        playersChats.length === 0 &&
        trainersChats.length === 0 &&
        !$store.state.loading
      "
    >
      Im Moment hast du keine aktiven Chats.
    </h3>

    <h2 v-if="playersChats.length !== 0">Spieler</h2>
    <ChatPreview
      @click="redirectToChat(matchChat.chat_id)"
      @open-profile="openProfile(matchChat.contactDetails, matchChat.chat_id)"
      class="player-preview"
      v-for="matchChat in playersChats"
      :key="matchChat.chat_id"
      :picture="matchChat.profile_pic"
      :msg="matchChat.lastMessage"
      :name="matchChat.player_name"
      :chat-id="matchChat.chat_id"
      :lastMessageDetails="matchChat.lastMessageDetails"
      :inactiveInfo="matchChat.disabledBy"
    ></ChatPreview>

    <h2 v-if="trainersChats.length !== 0">Trainer</h2>
    <ChatPreview
      @click="redirectToChat(matchChat.chat_id)"
      @open-profile="openProfile(matchChat.contactDetails, matchChat.chat_id)"
      class="player-preview"
      v-for="matchChat in trainersChats"
      :key="matchChat.chat_id"
      :picture="matchChat.profile_pic"
      :msg="matchChat.lastMessage"
      :name="matchChat.player_name"
      :chat-id="matchChat.chat_id"
      :lastMessageDetails="matchChat.lastMessageDetails"
      :inactiveInfo="matchChat.disabledBy"
    ></ChatPreview>

    <h2 v-if="scoutsChats.length !== 0">Scouts</h2>
    <ChatPreview
      @click="
        redirectToChat(
          matchChat.chat_id,
          matchChat.logo,
          matchChat.team ? matchChat.team : matchChat.name,
          matchChat.contactByDetails,
        )
      "
      @open-profile="openProfile(matchChat.contactByDetails, matchChat.chat_id)"
      class="player-preview"
      v-for="matchChat in scoutsChats"
      :key="matchChat.chat_id"
      :picture="matchChat.logo"
      :msg="matchChat.lastMessage"
      :name="matchChat.team"
      :chat-id="matchChat.chat_id"
      :lastMessageDetails="matchChat.lastMessageDetails"
      :inactiveInfo="matchChat.disabledBy"
    ></ChatPreview>

    <MatchSheetPlayer
      v-if="showProfile.player"
      :selectedProfile="selectedProfile"
      @close="showProfile.player = false"
      :show="showProfile.player"
      :showMatchButtons="false"
    ></MatchSheetPlayer>

    <MatchSheetTrainer
      v-if="showProfile.trainer"
      :selectedProfile="selectedProfile"
      @close="showProfile.trainer = false"
      :show="showProfile.trainer"
      :showMatchButtons="false"
    ></MatchSheetTrainer>

    <MatchSheetTeam
      v-if="showProfile.teams"
      :selectedProfile="selectedProfile"
      @close="showProfile.teams = false"
      :show="showProfile.teams"
      :showMatchButtons="false"
    ></MatchSheetTeam>

    <MatchSheetScout
      v-if="showProfile.scout"
      :selectedProfile="selectedProfile"
      @close="showProfile.scout = false"
      :show="showProfile.scout"
      :showMatchButtons="false"
    ></MatchSheetScout>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import { db } from '@/db';
import ChatPreview from '@/components/chat/ChatPreview';
import ChatInactivePreview from '@/components/chat/ChatInactivePreview';
import matchMixin from '../../mixins/match';
import chatProfiles from '../../mixins/chat-profiles';
import common from '../../mixins/common';

export default {
  name: 'team-matches',

  components: {
    ChatPreview,
    ChatInactivePreview,
  },

  mixins: [matchMixin, chatProfiles, common],

  computed: {
    ...mapState(['userMatches']),

    playersChats() {
      return this.userMatches
        ? _.orderBy(
            this.userMatches
              .filter((match) => match.type === 'player')
              .filter(
                (m) => !m.disabledBy || !m.disabledBy.includes(this.user_data.id),
              ),
            ['timestamp'],
            ['desc'],
          )
        : [];
    },
    trainersChats() {
      return this.userMatches
        ? _.orderBy(
            this.userMatches
              .filter((match) => match.type === 'trainer')
              .filter(
                (m) => !m.disabledBy || !m.disabledBy.includes(this.user_data.id),
              ),
            ['timestamp'],
            ['desc'],
          )
        : [];
    },
    scoutsChats() {
      return this.userMatches
        ? _.orderBy(
            this.userMatches
              .filter((match) => match.type === 'teams')
              .filter(
                (m) => !m.disabledBy || !m.disabledBy.includes(this.user_data.id),
              ),
            ['timestamp'],
            ['desc'],
          )
        : [];
    },

    matchesArchived() {
      return this.userMatches
        ? this.userMatches.filter(
            (m) => m.disabledBy && m.disabledBy.includes(this.user_data.id),
          )
        : [];
    },
  },

  async beforeMount() {
    // refresh last messages
    await this.fetchChats(this.user_data.matches);
  },

  beforeDestroy() {
    if (this.$store.state.user_data.newMatch) {
      this.$store.state.user_data.newMatch = 0;
      db.collection('teams')
        .doc(this.$store.state.user_data.id)
        .update({ newMatch: 0 });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.chat-wrapper {
  display: flex;
  flex-direction: column;
}

.matches-wrapper {
  width: 100%;
  text-align: left;
}
</style>
